/*============================================================================
  DiamondBoss: keep Aris/Avis option charges in step with their ring
  ----------------------------------------------------------------------------
  The options app adds paid upgrades (e.g. "Color: E" +$50) as separate
  "Avis-add-charge" cart lines. Each ring line carries `_apo_order: <id>` and
  each charge carries `_apo_order: "Added by: <id> * <n>"`. If a ring is
  removed or its quantity changes, the charge must follow, otherwise the
  customer is over- or under-charged. The app tries to do this itself but only
  for cart layouts it recognises, so we enforce it here too.

  Rules (idempotent, safe to run alongside the app):
  - charge quantity = (total quantity of its ring) * n
  - charge whose ring is no longer in the cart -> removed
==============================================================================*/
;(function () {
  var ORDER_KEY = '_apo_order'
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null
  var running = false
  var pending = false

  function parseCharge(value) {
    // "Added by: 1791509401411 * 1"  ->  { id: "1791509401411", per: 1 }
    var m = String(value).match(/Added by:\s*([^*\s]+)\s*(?:\*\s*(\d+))?/)
    if (!m) return null
    return { id: m[1], per: m[2] ? parseInt(m[2], 10) : 1 }
  }

  function desiredUpdates(cart) {
    var ringQty = {}
    var charges = []

    cart.items.forEach(function (item) {
      var p = item.properties || {}
      var v = p[ORDER_KEY]
      if (v === undefined || v === null || v === '') return
      if (String(v).indexOf('Added by:') === 0) {
        var c = parseCharge(v)
        if (c) charges.push({ item: item, id: c.id, per: c.per })
      } else {
        ringQty[String(v)] = (ringQty[String(v)] || 0) + item.quantity
      }
    })

    // Several charge lines can point at the same ring (one per paid option); each follows the ring.
    var updates = {}
    var changed = false
    charges.forEach(function (c) {
      var want = (ringQty[c.id] || 0) * c.per
      if (c.item.quantity !== want) {
        updates[c.item.key] = want
        changed = true
      }
    })
    return changed ? updates : null
  }

  // "Edit ring" (assets/db-edit-ring.js): once the edited ring is back in the cart, drop the old line
  var EDIT_KEY = 'dbEditRing'
  function editUpdates(cart) {
    var pending
    try { pending = JSON.parse(sessionStorage.getItem(EDIT_KEY) || 'null') } catch (e) { pending = null }
    if (!pending) return null
    var clear = function () { try { sessionStorage.removeItem(EDIT_KEY) } catch (e) {} }
    if (Date.now() - pending.ts > 30 * 60 * 1000) { clear(); return null }
    var old = cart.items.filter(function (i) { return i.key === pending.key })[0]
    if (!old) { clear(); return null }
    var isRing = function (i) { var p = i.properties || {}; return !p._apo_option && String(p[ORDER_KEY] || '').indexOf('Added by:') !== 0 }
    var replacement = cart.items.filter(function (i) {
      return i.product_id === pending.productId && i.key !== pending.key && isRing(i)
    })[0]
    var updates = {}
    if (replacement) {
      updates[old.key] = 0
    } else if (old.quantity > pending.qty) {
      // Nothing changed, so Shopify merged the re-add into the same line
      updates[old.key] = pending.qty
    } else {
      return null // the new ring hasn't been added yet
    }
    clear()
    return updates
  }

  function refreshUi() {
    if (window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart?') === 0) {
      window.location.reload()
      return
    }
    document.dispatchEvent(new CustomEvent('cart:build'))
  }

  function sync() {
    if (!nativeFetch) return
    if (running) {
      pending = true
      return
    }
    running = true
    nativeFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json() })
      .then(function (cart) {
        var updates = editUpdates(cart)
        if (updates) {
          // Charges are re-synced in the follow-up pass, once the old ring is gone
          pending = true
        } else {
          updates = desiredUpdates(cart)
        }
        if (!updates) return false
        return nativeFetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { return true })
      })
      .then(function (didUpdate) {
        if (didUpdate) refreshUi()
      })
      .catch(function () {})
      .finally(function () {
        running = false
        if (pending) {
          pending = false
          sync()
        }
      })
  }

  var timer = null
  function schedule() {
    clearTimeout(timer)
    // Let the theme/app finish their own cart request first
    timer = setTimeout(sync, 600)
  }

  // Theme quantity changes and drawer opens
  document.addEventListener('cart:updated', schedule)
  document.addEventListener('CartDrawer:open', schedule)

  // Any other cart change made with fetch (drawer remove, app updates)
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || ''
      var p = nativeFetch(input, init)
      if (/\/cart\/(change|update|add|clear)(\.js)?/.test(url)) {
        p.then(schedule, schedule)
      }
      return p
    }
  }

  // Page loads (covers the cart page after a "Remove" link reloads it)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule)
  } else {
    schedule()
  }
})()
